import { render } from "./SaleSharedFeesTable.vue?vue&type=template&id=4ba6ae00"
import script from "./SaleSharedFeesTable.vue?vue&type=script&lang=js"
export * from "./SaleSharedFeesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__